export  default {
    getDivisions(state) {
        return state.divisions;
    },
    getCurrentDivision(state) {
        return state.currentDivision;
    },
};